import { generateCanonicalLinks } from "@forge42/seo-tools/canonical";

type CanonicalOptions = {
  domain: string;
  path: string;
  alternatives?: { locale: string; url: string }[];
};

export function buildCanonical(domain: string, path: string) {
  return generateCanonicalLinks(
    {
      domain,
      url: path,
      canonicalUrl: `${domain}${path}`,
      urlTransformer: ({ domain: d, url }) => `${d}${url}`,
      alternatives: [],
    },
    true
  );
}

export function buildCanonicalWithAlternatives(opts: CanonicalOptions) {
  return generateCanonicalLinks(
    {
      domain: opts.domain,
      url: opts.path,
      canonicalUrl: `${opts.domain}${opts.path}`,
      urlTransformer: ({ domain: d, url }) => `${d}${url}`,
      altAttributesTransformer: ({ alternative }) => ({
        hreflang: alternative.locale,
      }),
      alternatives: opts.alternatives || [],
    },
    true
  );
}
